<div>
  <h2>{{ "PRIVACY_POLICY.PRIVACY_POLICY" | translate : locale.language }}</h2>

  <h4>
    {{
      "PRIVACY_POLICY.DATA_PROTECTION_AT_GLANCE.DATA_PROTECTION_AT_GLANCE"
        | translate : locale.language
    }}
  </h4>

  <h5>
    {{
      "PRIVACY_POLICY.DATA_PROTECTION_AT_GLANCE.GENERAL_INFORMATION_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.DATA_PROTECTION_AT_GLANCE.GENERAL_INFORMATION_TEXT"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.DATA_PROTECTION_AT_GLANCE.DATA_COLLECTION"
        | translate : locale.language
    }}
  </h5>
  <p>
    <strong>{{
      "PRIVACY_POLICY.DATA_PROTECTION_AT_GLANCE.RESPONSIBILITY_TITLE"
        | translate : locale.language
    }}</strong>
  </p>
  <article>
    {{
      "PRIVACY_POLICY.DATA_PROTECTION_AT_GLANCE.RESPONSIBILITY_TEXT"
        | translate : locale.language
    }}
  </article>

  <p>
    <strong>{{
      "PRIVACY_POLICY.DATA_PROTECTION_AT_GLANCE.COLLECTION_TITLE"
        | translate : locale.language
    }}</strong>
  </p>
  <article>
    {{
      "PRIVACY_POLICY.DATA_PROTECTION_AT_GLANCE.COLLECTION_TEXT"
        | translate : locale.language
    }}
  </article>

  <p>
    <strong>{{
      "PRIVACY_POLICY.DATA_PROTECTION_AT_GLANCE.USAGE_TITLE"
        | translate : locale.language
    }}</strong>
  </p>
  <article>
    {{
      "PRIVACY_POLICY.DATA_PROTECTION_AT_GLANCE.USAGE_TEXT"
        | translate : locale.language
    }}
  </article>

  <p>
    <strong>{{
      "PRIVACY_POLICY.DATA_PROTECTION_AT_GLANCE.RIGHTS_TITLE"
        | translate : locale.language
    }}</strong>
  </p>
  <article>
    {{
      "PRIVACY_POLICY.DATA_PROTECTION_AT_GLANCE.RIGHTS_TEXT_1"
        | translate : locale.language
    }}
  </article>
  <article>
    {{
      "PRIVACY_POLICY.DATA_PROTECTION_AT_GLANCE.RIGHTS_TEXT_2"
        | translate : locale.language
    }}
  </article>
  <br />

  <h4>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION"
        | translate : locale.language
    }}
  </h4>

  <h5>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.DATA_PROTECTION_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.DATA_PROTECTION_TEXT_1"
        | translate : locale.language
    }}
  </article>
  <article>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.DATA_PROTECTION_TEXT_2"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESPONSIBLE_ENTITY_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESPONSIBLE_ENTITY_INTRO"
        | translate : locale.language
    }}
    <br />
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESPONSIBLE_ENTITY_COMPANY"
        | translate : locale.language
    }}
    <br />
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESPONSIBLE_ENTITY_STREET"
        | translate : locale.language
    }}
    <br />
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESPONSIBLE_ENTITY_CITY"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESPONSIBLE_ENTITY_PHONE"
        | translate : locale.language
    }}
    <br />
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESPONSIBLE_ENTITY_EMAIL"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESPONSIBLE_ENTITY_OUTRO"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.WITHDRAWAL_DATA_PROCESSING_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.WITHDRAWAL_DATA_PROCESSING_TEXT"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.WITHDRAWAL_DATA_PROCESSING_LAW_1"
        | translate : locale.language
    }}
  </h5>
  <article>
    <strong>
      {{
        "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.WITHDRAWAL_DATA_PROCESSING_LAW_2"
          | translate : locale.language
      }}
      <br /><br />
      {{
        "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.WITHDRAWAL_DATA_PROCESSING_LAW_3"
          | translate : locale.language
      }}
    </strong>
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RIGHT_TO_FILE_A_COMPLAINT_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RIGHT_TO_FILE_A_COMPLAINT_TEXT"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RIGHT_TO_DATA_PORTABILITY_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RIGHT_TO_DATA_PORTABILITY_TEXT"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.SSL_OR_TLS_ENCRYPTION_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.SSL_OR_TLS_ENCRYPTION_TEXT_1"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.SSL_OR_TLS_ENCRYPTION_TEXT_2"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.INFORMATION_BLOCKING_DELETION_AND_CORRECTION_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.INFORMATION_BLOCKING_DELETION_AND_CORRECTION_TEXT"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESTRICTION_OF_PROCESSING_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESTRICTION_OF_PROCESSING_TEXT_1"
        | translate : locale.language
    }}
    <ul>
      <li>
        {{
          "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESTRICTION_OF_PROCESSING_LIST_1"
            | translate : locale.language
        }}
      </li>
      <li>
        {{
          "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESTRICTION_OF_PROCESSING_LIST_2"
            | translate : locale.language
        }}
      </li>
      <li>
        {{
          "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESTRICTION_OF_PROCESSING_LIST_3"
            | translate : locale.language
        }}
      </li>
      <li>
        {{
          "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESTRICTION_OF_PROCESSING_LIST_4"
            | translate : locale.language
        }}
      </li>
      <li>
        {{
          "PRIVACY_POLICY.GENERAL_INFORMATION_AND_MANDATORY_INFORMATION.RESTRICTION_OF_PROCESSING_LIST_5"
            | translate : locale.language
        }}
      </li>
    </ul>
  </article>

  <br />
  <h4>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.DATA_COLLECTION_ON_OUR_WEBSITE"
        | translate : locale.language
    }}
  </h4>
  <h5>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.COOKIES_TITLE"
        | translate : locale.language
    }}
  </h5>

  <article>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.COOKIES_TEXT_1"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.COOKIES_TEXT_2"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.COOKIES_TEXT_3"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.COOKIES_TEXT_4"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.SERVER_LOG_DATA_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.SERVER_LOG_DATA_TEXT_1"
        | translate : locale.language
    }}
    <ul>
      <li>
        {{
          "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.SERVER_LOG_DATA_LIST_1"
            | translate : locale.language
        }}
      </li>
      <li>
        {{
          "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.SERVER_LOG_DATA_LIST_2"
            | translate : locale.language
        }}
      </li>
      <li>
        {{
          "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.SERVER_LOG_DATA_LIST_3"
            | translate : locale.language
        }}
      </li>
      <li>
        {{
          "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.SERVER_LOG_DATA_LIST_4"
            | translate : locale.language
        }}
      </li>
      <li>
        {{
          "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.SERVER_LOG_DATA_LIST_5"
            | translate : locale.language
        }}
      </li>
      <li>
        {{
          "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.SERVER_LOG_DATA_LIST_6"
            | translate : locale.language
        }}
      </li>
    </ul>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.SERVER_LOG_DATA_TEXT_2"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.SERVER_LOG_DATA_TEXT_3"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.CONTACT_FORM_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.CONTACT_FORM_TEXT_1"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.CONTACT_FORM_TEXT_2"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.CONTACT_FORM_TEXT_3"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.REQUEST_BY_MAIL_PHONE_OR_FAX_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.REQUEST_BY_MAIL_PHONE_OR_FAX_TEXT_1"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.REQUEST_BY_MAIL_PHONE_OR_FAX_TEXT_2"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.REQUEST_BY_MAIL_PHONE_OR_FAX_TEXT_3"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.REGISTRATION_ON_THIS_WEBSITE_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.REGISTRATION_ON_THIS_WEBSITE_TEXT_1"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.REGISTRATION_ON_THIS_WEBSITE_TEXT_2"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.REGISTRATION_ON_THIS_WEBSITE_TEXT_3"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.REGISTRATION_ON_THIS_WEBSITE_TEXT_4"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.PROCESSING_OF_DATA_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.PROCESSING_OF_DATA_TEXT_1"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.DATA_COLLECTION_ON_OUR_WEBSITE.PROCESSING_OF_DATA_TEXT_2"
        | translate : locale.language
    }}
  </article>

  <br />

  <h4>
    {{
      "PRIVACY_POLICY.PLUGINS_AND_TOOLS.PLUGINS_AND_TOOLS"
        | translate : locale.language
    }}
  </h4>
  <h5>
    {{
      "PRIVACY_POLICY.PLUGINS_AND_TOOLS.GOOGLE_RECAPTCHA_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.PLUGINS_AND_TOOLS.GOOGLE_RECAPTCHA_TEXT_1"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.PLUGINS_AND_TOOLS.GOOGLE_RECAPTCHA_TEXT_2"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.PLUGINS_AND_TOOLS.GOOGLE_RECAPTCHA_TEXT_3"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.PLUGINS_AND_TOOLS.GOOGLE_RECAPTCHA_TEXT_4"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.PLUGINS_AND_TOOLS.GOOGLE_RECAPTCHA_TEXT_5"
        | translate : locale.language
    }}
    <br /><br />
    <a
      class="color-occon-red-mid"
      href="{{
        'PRIVACY_POLICY.PLUGINS_AND_TOOLS.GOOGLE_RECAPTCHA_LINK_1'
          | translate : locale.language
      }}"
      >{{
        "PRIVACY_POLICY.PLUGINS_AND_TOOLS.GOOGLE_RECAPTCHA_LINK_1"
          | translate : locale.language
      }}</a
    >
    <br />{{
      "PRIVACY_POLICY.PLUGINS_AND_TOOLS.GOOGLE_RECAPTCHA_LINK_2"
        | translate : locale.language
    }}<br />
    <a
      class="color-occon-red-mid"
      href="{{
        'PRIVACY_POLICY.PLUGINS_AND_TOOLS.GOOGLE_RECAPTCHA_LINK_3'
          | translate : locale.language
      }}"
      >{{
        "PRIVACY_POLICY.PLUGINS_AND_TOOLS.GOOGLE_RECAPTCHA_LINK_3"
          | translate : locale.language
      }}</a
    >
  </article>

  <br />
  <h4>
    {{
      "PRIVACY_POLICY.OWN_SERVICES.OWN_SERVICES" | translate : locale.language
    }}
  </h4>

  <h5>
    {{
      "PRIVACY_POLICY.OWN_SERVICES.APPLICATIONS_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.OWN_SERVICES.APPLICATIONS_TEXT"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.OWN_SERVICES.SCOPE_AND_PURPOSE_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.OWN_SERVICES.SCOPE_AND_PURPOSE_TEXT_1"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.OWN_SERVICES.SCOPE_AND_PURPOSE_TEXT_2"
        | translate : locale.language
    }}
  </article>

  <h5>
    {{
      "PRIVACY_POLICY.OWN_SERVICES.RETENTION_PERIOD_TITLE"
        | translate : locale.language
    }}
  </h5>
  <article>
    {{
      "PRIVACY_POLICY.OWN_SERVICES.RETENTION_PERIOD_TEXT_1"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.OWN_SERVICES.RETENTION_PERIOD_TEXT_2"
        | translate : locale.language
    }}
    <br /><br />
    {{
      "PRIVACY_POLICY.OWN_SERVICES.RETENTION_PERIOD_TEXT_3"
        | translate : locale.language
    }}
  </article>
</div>
